export const resources = {
  InsightsWidgetPoweredBy: '',
  InsightsWidgetPoweredByFF: ''
};
